export const environment = {
    production: true,
    VERSION : "31345"
};